import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { SecurityService } from '@app/_core/services/security.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { UserService } from '@app/_core/services/user.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, lastValueFrom, map } from 'rxjs';
import { UsermenuvoicemailsComponent } from '@app/pages/console/usermenuvoicemail/usermenuvoicemails/usermenuvoicemails.component';
import { DialerService } from '@app/_core/services/dialer.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
interface CategoryInterface {
    status: string;
    statusID: number;
}
@Component({
    selector: 'app-current-status-message',
    templateUrl: './current-status-message.component.html',
    styleUrls: ['./current-status-message.component.scss'],
})
export class CurrentStatusMessageComponent implements OnInit {
    @Input()
    modalRef?: BsModalRef;
    @Input() ShowOkButton:boolean=true
    status: any;
    clientAbbreviation: string;
    display: any;
    isTimedOut: boolean = true;
    isTimerRequired: boolean = true;
    public timerInterval: any;
    statusList: CategoryInterface[] = [
        {
            status: 'Away',
            statusID: 9,
        },
    ];
    selectedQueueId: any;
    selectedStatus!: CategoryInterface;
    queuesRes: any;
    showChangeQueue: boolean;
    constructor(
        @Inject(APP_BASE_HREF) public baseHref: string,
        public bsModalRef: BsModalRef,
        private router: Router,
        private tmQueueService: TmQueueService,
        private appService: AppService,
        private securityService: SecurityService,
        private userService: UserService,
        private modalService: BsModalService,
        private dailerService: DialerService,
        private queuesService: QueuesService,
        private mainController: MainControllerComponent
        
    ) { }
    getUserStatus() {
        this.selectedStatus = this.statusList[0];
    }
    async ngOnInit() {
        //console.log(this.status)
        this.dailerService.setIsStatusModalOpen(true);
        // const data: any = await lastValueFrom(this.tmQueueService.getQueues());
        const data: any = this.tmQueueService.getcurrentQueueData();
        this.queuesRes = data.Response.Data;
        if (this.queuesRes.length == 1) {
            if ((data.Response?.Data[0]?.DialerType == 'AutomatedInbound' || data?.Response?.Data[0]?.DialerType == 'Progressive') && data?.Response?.Data[0]?.Name == 'Inbound') {
                this.showChangeQueue = true;
            }
            else {
                this.showChangeQueue = false;
            }

        } else {
            this.showChangeQueue = true;
        }
        this.clientAbbreviation = Utils.fetch('clientAbbreviation');
        this.getStatusDetails();
        this.getUserStatus();
        this.statusChange();
        this.dailerService.setPhoneNo('');
        this.dailerService.setResetCallSummary(true);

    }
    statusChange() {
        if (this.dailerService.getIsAgentStatusChangeRequired()) {
            this.setUserStatus(this.selectedStatus.statusID, null);
            this.appService.setAgentStatus(this.selectedStatus.statusID);
           // console.log('statusChange', this.selectedStatus);
        }
        // this.CallStatusChangeEvents.next(this.selectedStatus);
        //this.queuesService.setTaskMenuQueueSelected(false);
    }
    getStatusDetails() {
        this.tmQueueService.getStatusDetails().subscribe(response => {
            response.Response.Data.forEach(element => {
                this.statusList.push({
                    status: element.label,
                    statusID: element.value,
                });
            });
            //this.selectedStatus = this.statusList[0];
            //this.dailerService.setIsBlockLoader(false);
        });
    }
    setUserStatus(statusID: any, queueID: any) {
        this.tmQueueService
            .setUserStatus(statusID, queueID)
            .pipe(
                map((data: any) => {
                    this.stop();
                    if (data.Response.Data) {
                        this.start(data.Response.Data);
                        this.isTimerRequired = true;
                    }
                }),
                catchError(error => {
                    console.log(error);
                    return EMPTY;
                })
            )
            .subscribe();
    }
    onResumeCall() {
        try {
            this.dailerService.setIsAgentStatusChangeRequired(false);
            //this.appService.setAgentStatus(null);
            let route=this.queuesService.getQueueRoute();

            if (route && route.toLowerCase().includes('inbound')) {
                this.dailerService.setConnections(true);
                this.dailerService.setResumeCalling(true);
                this.dailerService.setDialerCancelledStatus(false);
                this.mainController.setAllDialerWindowStatus(false, true, false);
            }
            else if (this.router.url.toLowerCase().includes('console')) {
                this.appService.setUserStatus(12, null);
            }
            else if (this.router.url.toLowerCase().includes('performance')) {
                this.appService.setUserStatus(10, null);
            }
            else if (this.router.url.toLowerCase().includes('casedetails')) {
                this.navigateFromCaseDetails()
            }
            else {
                this.appService.setUserStatus(6, this.queuesService.getselectedQueueId()??null);
            }
        } catch (err) {
            console.log('onResumeCall failed', err);
        } finally {
            this.bsModalRef.hide();
        }
    }
    onChangeQueue() {
        this.bsModalRef.hide();
        //this.queuesService.notifyOtherFromTaskMenu({
        //    refresh: false,
        //    menuName: '',
        //});
        this.dailerService.setIsAgentStatusChangeRequired(false);
        this.dailerService.setDialerCancelledStatus(false);
        this.tmQueueService.setisTopMenuQueueSelected(true);
        this.tmQueueService.setisQueueTaskMenuLoaded(true);
        
        this.queuesService.setTaskMenuQueueSelected({
            pageRefresh: false,
            isPageInitCompleted: true,
            queueType: 'Inbound'
        }
        );
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue']);
    }
    onPerformance() {
        this.bsModalRef.hide();
        let currMenu = {
            listmenu: this.clientAbbreviation + '/Performance',
            menu: '',
            submenu: '',
            name: '',
            action: this.clientAbbreviation + '/Performance',
        };
        this.dailerService.setIsAgentStatusChangeRequired(false);
        this.appService.setUserStatus(10, null);
        this.appService.setCurrentMenu(currMenu);
        this.queuesService.setTaskMenuQueueSelected({
            pageRefresh: false,
            isPageInitCompleted: true
        });
        this.router.navigate([this.clientAbbreviation + '/Performance']);
    }
    navigateFromCaseDetails()
    {
        if (this.router.url.toLowerCase().includes('casedetails')) {
            let route=this.queuesService.getQueueRoute();
            if(route){
                if(this.router.url!=route && route.includes("?")){
                    let qid=route.split("?")[1].split("=")[1]
                    if(qid){
                        this.router.navigate([route.split("?")[0]],{
                            queryParams: { qid: qid },
                        });
                    }
                    else{
                        this.router.navigate([route.split("?")[0]]);
                    }
                }
                else
                {
                    this.router.navigate([route.split("?")[0]]);
                }
             }
        }
    }
    onVoicemail() {
        this.bsModalRef.hide();
        this.navigateFromCaseDetails()
        // let currMenu = {
        //   listmenu: this.clientAbbreviation + '/Console',
        //   menu: 'Voicemails',
        //   submenu: '',
        //   name: 'Voicemails',
        //   action: this.clientAbbreviation + '/Console/Voicemails',
        // };
        // this.appService.setCurrentMenu(currMenu);
        // this.router.navigate([this.clientAbbreviation + '/Console/Voicemails']);
        //const config: ModalOptions = { class: 'modal-xl' };
        const config: ModalOptions = {
            class: 'modal-xl',
            backdrop: 'static',
            keyboard: false

        };
        this.dailerService.setDialerCancelledStatus(false);
        this.dailerService.setIsAgentStatusChangeRequired(false);
        this.appService.setUserStatus(6, null);
        this.queuesService.setTaskMenuQueueSelected({
            pageRefresh: false,
            isPageInitCompleted: true
        });
        this.modalRef = this.modalService.show(UsermenuvoicemailsComponent, config);
        //this.modalRef?.content?.event?.subscribe((result: any) => { });
    }
    onLogout() {

        this.queuesService.setTaskMenuQueueSelected({
            pageRefresh: false,
            isPageInitCompleted: true
        });
        this.dailerService.setIsAgentStatusChangeRequired(false);
        this.router.navigate([this.clientAbbreviation + '']);
        this.tmQueueService.setUserStatus(2, null).subscribe((result: any) => {
            this.appService.setCurrentMenu(null);
            Utils.store('clientAbbreviation', null);
            this.securityService.clientAbbr = null;
            this.userService.logout();
            this.bsModalRef.hide();
        });
    }
    closeStatusPopup() {
        this.bsModalRef.hide();
    }

    start(minute) {
        this.timer(minute);
    }
    stop() {
        clearInterval(this.timerInterval);
    }

    timer(minute) {
        // let minute = 1;
        let seconds: number = minute * 60;
        let textSec: any = '0';
        let statSec: number = 60;

        const prefix = minute < 10 ? '0' : '';

        this.timerInterval = setInterval(() => {
            seconds--;
            if (statSec != 0) statSec--;
            else statSec = 59;

            if (statSec < 10) {
                textSec = '0' + statSec;
            } else textSec = statSec;

            this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
            this.isTimedOut = Math.floor(seconds / 60) < 3 ? true : false;
            if (seconds == 0) {
               // console.log('finished');
                clearInterval(this.timerInterval);
            }
        }, 1000);
    }
    ngOnDestroy() {
       // console.log('setAgentStatus closed');
        //this.appService.setAgentStatus(null);
        this.dailerService.setIsStatusModalOpen(false);
        clearInterval(this.timerInterval);
    }

   
}
